import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { CircleX, X } from "lucide-react";
import React from "react";
import { ReactComponent as HandEye } from "../../assests/HandEye.svg";

const CustomModal = ({
  open,
  cancel,
  accept,
  handlePopup,
  header,
  firstLine,
  secondLine,
  cancelAction,
  confirmAction,
  child = false,
  component,
  children = null,
  steps,
  isSubmitting = false,
  containerRef,
  middleAction,
  middleActionText,
  needCloseBtn = false

}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handlePopup}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <DialogContent containerRef={containerRef} className="max-w-md max-h-[90vh] overflow-y-auto [&_*]:!font-sans">
          {/* Custom modal content */}
          {needCloseBtn ?
            <Button
              id="modal-close"
              onClick={handlePopup}
              className="rounded-full bg-transparent p-0 h-auto shadow-none hover:bg-transparent absolute top-[10px] right-[10px]"
            >
              <CircleX className="!w-6 !h-6 text-form-label" />
            </Button>
            : ""}
          {child ? (
            <div className="flex flex-col gap-7">
              <div className="flex items-center justify-between">
                <h4 className="text-md font-semibold w-[25ch] break-words">
                  {header}
                </h4>
                <Button
                  id="modal-close"
                  onClick={handlePopup}
                  className="rounded-full bg-transparent p-0 h-auto shadow-none hover:bg-transparent"
                >
                  <CircleX className="!w-6 !h-6 text-form-label" />
                </Button>
              </div>
              {component}
              <div className="flex flex-row justify-center items-center gap-3">
                {cancelAction && (
                  <Button
                    id="modal-cancel-button"
                    onClick={cancel}
                    disabled={isSubmitting}
                    className="px-6 py-4 text-lg font-normal"
                    variant="destructive"
                  >
                    <h5 className="text-sm font-semibold">{cancelAction}</h5>
                  </Button>
                )}
                <Button
                  id="modal-confirm-button"
                  onClick={accept}
                  disabled={isSubmitting}
                  className="px-6 py-4 !bg-primary"
                >
                  <h5 className="text-sm font-semibold">{confirmAction}</h5>
                </Button>
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12 md:col-span-4 flex items-center justify-center">
                <HandEye className="text-form-label" />
              </div>

              <div className="col-span-12 md:col-span-8 flex flex-col justify-center">
                <h6 className="text-sm font-semibold mb-2">{header}</h6>

                <div className="grid gap-1 p-2">
                  {firstLine && secondLine ? (
                    // Show bullet points only when both exist
                    <ul className="list-disc pl-5 space-y-1">
                      <li className="text-sm font-normal">{firstLine}</li>
                      <li className="text-sm font-normal">{secondLine}</li>
                    </ul>
                  ) : (
                    // Show plain text when only one line exists
                    <p className="text-sm font-normal">
                      {firstLine || secondLine}
                    </p>
                  )}
                </div>
                {steps && steps.length > 0 && (
                  <div className="grid gap-2 p-2">
                    {steps.length > 1 ? (
                      // Show bullets only when more than 1 step
                      <ul className="list-disc pl-5 space-y-2">
                        {steps.map((step, idx) => (
                          <li key={idx} className="text-sm font-normal">{step}</li>
                        ))}
                      </ul>
                    ) : (
                      // Only one step → show as plain text
                      <p className="text-sm font-normal">{steps[0]}</p>
                    )}
                  </div>
                )}
                {children}
              </div>

              <div className="col-span-12 flex flex-row justify-center items-center gap-3 w-full">
                {cancelAction && (
                  <Button
                    id="modal-cancel-button"
                    onClick={cancel}
                    disabled={isSubmitting}
                    className="px-6 py-4 text-lg font-normal  rounded-xl"
                    variant="destructive"
                  >
                    <h5 className="text-sm font-semibold">{cancelAction}</h5>
                  </Button>
                )}
                {middleAction && middleActionText && (
                  <Button
                    id="modal-middle-button"
                    onClick={middleAction}
                    disabled={isSubmitting}
                    className="px-6 py-4 !bg-primary"
                  >
                    <h5 className="text-sm font-semibold">{middleActionText}</h5>
                  </Button>
                )}
                {confirmAction &&
                  <Button
                    id="modal-confirm-button"
                    onClick={accept}
                    disabled={isSubmitting}
                    className="px-6 py-4 !bg-primary rounded-xl"
                  >
                    <h5 className="text-sm font-semibold">{confirmAction}</h5>
                  </Button>
                }
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );

};

export default React.memo(CustomModal);




// import React, { useState } from "react";
// import {
//   Button,
//   Grid,
//   Modal,
//   Typography,
//   TextField,
//   Stack,
// } from "@mui/material";
// import IconButton from "@mui/material/IconButton";
// import CloseIcon from "@mui/icons-material/Close";
// import { styled } from "@mui/system";
// import HandEye from "../../assests/HandEye.svg";
// import { CustomButton } from "./PopoverButton";

// // Create a custom styled component for the modal content
// const CustomModalContent = styled("div")(({ theme }) => ({
//   width: "fitContent",
//   maxWidth: "30%",
//   height: "fitContent%",
//   font: "Inter",
//   padding: "3rem", // top right bottom left (added extra bottom padding)
//   gap: "28px",
//   borderRadius: "32px",
//   border: "none",
//   backgroundColor: theme.palette.background.primary,
//   "&:focus": {
//     outline: "none",
//   },
//   // "linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), linear-gradient(0deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4))",
// }));

// const CustomModal = ({
//   open,
//   cancel,
//   accept,
//   handlePopup,
//   header,
//   firstLine,
//   secondLine,
//   cancelAction,
//   confirmAction,
//   child = false,
//   component,
// }) => {
//   return (
//     <>
//       <Modal
//         open={open}
//         onClose={handlePopup}
//         aria-labelledby="modal-title"
//         aria-describedby="modal-description"
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//         disablePortal
//         // Customize backdrop properties to blur background
//         BackdropProps={{
//           sx: {
//             backdropFilter: "blur(16px)",
//             backgroundImage:
//               "linear-gradient(180deg, rgba(215, 208, 255, 0.2) 0%, rgba(203, 221, 255, 0.5) 100%)",
//           },
//         }}
//         disableBackdropClick
//       >
//         {/* Custom modal content */}
//         <CustomModalContent>
//           {child ? (
//             <Stack gap={4}>
//               <Stack
//                 flexDirection={"row"}
//                 justifyContent={"space-between"}
//                 alignItems={"flex-start"}
//                 paddingRight={1}
//               >
//                 <Typography
//                   variant="h4"
//                   fontWeight={"600"}
//                   style={{ textWrap: "wrap", width: "25ch" }}
//                   gutterBottom
//                 >
//                   {header}
//                 </Typography>
//                 <IconButton
//                   id="modal-close"
//                   color="black"
//                   size="medium"
//                   style={{
//                     backgroundColor: "rgba(28, 28, 28, 0.05)",
//                     borderRadius: 12,
//                   }}
//                   onClick={handlePopup}
//                 >
//                   <CloseIcon />
//                 </IconButton>
//               </Stack>
//               {component}
//               <Stack
//                 flexDirection={"row"}
//                 justifyContent={"center"}
//                 gap={3}
//                 alignItems={"center"}
//               >
//                 {cancelAction && <CustomButton
//                   id="modal-cancel-button"
//                   variant="contained"
//                   disableElevation
//                   onClick={cancel}
//                   style={{
//                     paddingBlock: 16,
//                     paddingInline: 24,
//                     barderRadius: 16,
//                     backgroundColor: "#1C1C1C0D",
//                     textTransform: "none",
//                     fontSize: "18px",
//                   }}
//                 >
//                   <Typography variant="h5" style={{ fontWeight: 400 }}>
//                     {cancelAction}
//                   </Typography>
//                 </CustomButton>}
//                 <CustomButton
//                   id="modal-confirm-button"
//                   variant="contained"
//                   disableElevation
//                   onClick={accept}
//                   style={{
//                     paddingBlock: 16,
//                     paddingInline: 24,
//                     barderRadius: 16,
//                     textTransform: "none",
//                     fontSize: "18px",
//                     backgroundColor: "theme.button.primary",
//                   }}
//                 >
//                   <Typography
//                     variant="h5"
//                     style={{ fontWeight: 400 }}
//                     color="text.white"
//                   >
//                     {confirmAction}
//                   </Typography>
//                 </CustomButton>
//               </Stack>
//             </Stack>
//           ) : (
//             <Grid container spacing={3}>
//               <Grid
//                 item
//                 xs={12}
//                 md={4}
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <img
//                   src={HandEye}
//                   alt="Your SVG"
//                   style={{ width: "33px", height: "42px" }}
//                 />
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 md={8}
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                 }}
//               >
//                 <Typography
//                   variant="h6"
//                   fontWeight={"600"}
//                   fontSize={"14"}
//                   gutterBottom
//                 >
//                   {header}
//                 </Typography>
//                 <Grid container spacing={1} padding={2}>
//                   {firstLine && (
//                     <Grid item xs={12} sx={{ textAlign: "left" }}>
//                       <Typography variant="body2">
//                        {secondLine && <strong>{1}:</strong>} {firstLine}
//                       </Typography>
//                     </Grid>
//                   )}
//                   {secondLine && (
//                     <Grid item xs={12} sx={{ textAlign: "left" }}>
//                       <Typography variant="body2">
//                         <strong>{2}:</strong> {secondLine}
//                       </Typography>
//                     </Grid>
//                   )}
//                 </Grid>
//               </Grid>
//               <Grid
//                 item
//                 xs={12}
//                 sx={{ display: "flex", justifyContent: "center" }}
//               >
//                 <CustomButton
//                   id="modal-cancel-button"
//                   variant="contained"
//                   disableElevation
//                   color="error"
//                   sx={{
//                     borderRadius: 3,
//                     paddingInline: 5,
//                     marginRight: 1,

//                     backgroundColor: "background.secondary",
//                     "&:hover": {
//                       "& .MuiTypography-root": {
//                         color: "white", // Change text color to white on hover
//                       },
//                       backgroundColor: "red",
//                     },
//                   }}
//                 >
//                   <Typography
//                     variant="button"
//                     sx={{
//                       color: "text.primary",
//                       textTransform: "none",
//                     }}
//                     onClick={cancel}
//                   >
//                     {cancelAction}
//                   </Typography>
//                 </CustomButton>
//                 <CustomButton
//                   id="modal-confirm-button"
//                   disableElevation
//                   variant="contained"
//                   sx={{
//                     background: "#5776E7",
//                     paddingInline: 5,
//                     borderRadius: 3,
//                   }}
//                   onClick={accept}
//                 >
//                   <Typography
//                     variant="button"
//                     sx={{ color: "white", textTransform: "none" }}
//                   >
//                     {confirmAction}
//                   </Typography>
//                 </CustomButton>
//               </Grid>
//             </Grid>
//           )}
//         </CustomModalContent>
//       </Modal>
//     </>
//   );

// };

// export default React.memo(CustomModal);


